import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import(/* webpackChunkName: "about" */ './views/Home.vue')
    }, {
      path: '/detail',
      name: 'detail',
      component: () => import(/* webpackChunkName: "about" */ './views/Detail.vue')
    }, {
      path: '/smgDetail',
      name: 'smgDetail',
      component: () => import(/* webpackChunkName: "about" */ './views/smgDetail.vue')
    }, {
      path: '/newsDetail',
      name: 'newsDetail',
      component: () => import(/* webpackChunkName: "about" */ './views/newsDetail.vue')
    }, {
      path: '/patternDetail',
      name: 'patternDetail',
      component: () => import(/* webpackChunkName: "about" */ './views/patternDetail.vue')
    }, {
      path: '/matchList',
      name: 'matchList',
      component: () => import(/* webpackChunkName: "about" */ './views/matchList.vue')
    }, {
      path: '/matchDetail',
      name: 'matchDetail',
      component: () => import(/* webpackChunkName: "about" */ './views/matchDetail.vue')
    }, {
      path: '/reportList',
      name: 'reportList',
      component: () => import(/* webpackChunkName: "about" */ './views/reportList.vue')
    }, {
      path: '/reportListDetail',
      name: 'reportListDetail',
      component: () => import(/* webpackChunkName: "about" */ './views/reportListDetail.vue')
    }, {
      path: '/advice',
      name: 'advice',
      component: () => import(/* webpackChunkName: "about" */ './views/advice.vue')
    }, {
      path: '/aboutUs',
      name: 'aboutUs',
      component: () => import(/* webpackChunkName: "about" */ './views/aboutUs.vue')
    }, {
      path: '/contactUs',
      name: 'contactUs',
      component: () => import(/* webpackChunkName: "about" */ './views/contactUs.vue')
    }, {
      path: '/copyRight',
      name: 'copyRight',
      component: () => import(/* webpackChunkName: "about" */ './views/copyRight.vue')
    }, {
      path: '/invisible',
      name: 'invisible',
      component: () => import(/* webpackChunkName: "about" */ './views/invisible.vue')
    }, {
      path: '/costum',
      name: 'costum',
      component: () => import(/* webpackChunkName: "about" */ './views/costum.vue')
    }, {
      path: '/allSearch',
      name: 'allSearch',
      component: () => import(/* webpackChunkName: "about" */ './views/allSearch.vue')
    }, {
      path: '/newsList',
      name: 'newsList',
      component: () => import(/* webpackChunkName: "about" */ './views/newsList.vue')
    }
  ]
})
